(() => {
  const stylesheet = `
    #app-embed[data-current-step="tease"] {
      bottom: calc(var(--private-preview-bar-offset, 0px) + var(--dw-purchase-offset, 0px)) !important;
      padding: 20px !important;
    }
    button[data-testid="form-teaser"] {
      box-sizing: border-box;
      height: 48px !important;
      min-height: 48px !important;
      min-width: 110px;
      padding: 0 18px !important;
      margin: 0 !important;
      gap: 12px;
      border: 1px solid #20211e !important;
      border-radius: 0 !important;
      background: #20211e !important;
      color: #fff !important;
      box-shadow: none !important;
      font: 400 14px/1 Manrope, Arial, sans-serif;
    }
    button[data-testid="form-teaser"] h3 {
      color: inherit;
      font: inherit;
      margin: 0;
    }
    button[data-testid="form-teaser"] [aria-label="Close modal"] {
      color: #fff;
      background: transparent;
      border-radius: 0;
    }
    button[data-testid="form-teaser"] [aria-label="Close modal"] svg {
      fill: currentColor;
    }
    button[data-testid="form-teaser"]:hover {
      background: #3a3b37 !important;
    }
    button[data-testid="form-teaser"]:focus-visible {
      outline: 2px solid #20211e;
      outline-offset: 3px;
    }
    @media (max-width: 749px) {
      #app-embed[data-current-step="tease"] {
        padding: 16px !important;
      }
    }

    /* Compact newsletter on phones; desktop retains the Forms layout. */
    @media (max-width: 749px) {
      #app-embed [role="dialog"][aria-label] {
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: 180px auto !important;
        width: calc(100vw - 32px) !important;
        min-width: 0 !important;
        box-sizing: border-box;
        max-width: 360px !important;
        max-height: calc(100dvh - 32px) !important;
        overflow-y: auto !important;
        overscroll-behavior: contain;
      }
      #app-embed [class*="_gridItem_"]:not([class*="_gridItemContent_"]) {
        height: 180px !important;
        min-height: 0 !important;
        background-position: center 35% !important;
      }
      #app-embed [class*="_gridItemContent_"] {
        padding: 18px 20px !important;
      }
      #app-embed [class*="_formHeader_"] {
        margin: 0 0 12px !important;
      }
      #app-embed h2 {
        font-size: 20px !important;
        line-height: 1.2 !important;
      }
      #app-embed [data-testid="form"] {
        gap: 10px !important;
      }
      #app-embed [data-testid="field-email"] {
        font-size: 16px !important;
      }
      #app-embed [class*="_formDisclaimer_"] {
        margin-top: 10px !important;
        padding: 0 !important;
        font-size: 11px !important;
        line-height: 1.35 !important;
      }
      #app-embed [aria-label="Close modal"] {
        min-width: 44px;
        min-height: 44px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
  `;
  const copyElement = document.getElementById('dw-forms-copy');
  let copy = {};
  try { copy = JSON.parse(copyElement?.textContent || '{}'); } catch {}
  const localize = (root) => {
    const form = root.querySelector('form[data-testid="form"]');
    if (form && copy.condition && !root.querySelector('[data-dw-newsletter-condition]')) {
      const note = document.createElement('p');
      note.dataset.dwNewsletterCondition = '';
      note.textContent = document.documentElement.lang.split('-')[0] === 'it'
        ? 'Esclusi i prodotti già in sconto'
        : copy.condition.replace(/^.*?\.\s*/, '');
      note.style.cssText = 'font-family:inherit;font-size:11px;line-height:1.35;margin:8px 0 0;text-align:center;';
      form.after(note);
    }
    if (document.documentElement.lang.split('-')[0] !== 'it') return;
    const disclaimer = root.querySelector('[class*="_formDisclaimer_"] p');
    if (disclaimer && disclaimer.textContent.trim() === 'By signing up, you agree to receive marketing emails. View our privacy policy and terms of service for more info.') {
      const privacy = document.createElement('a');
      privacy.href = '/policies/privacy-policy';
      privacy.textContent = copy.privacy;
      const terms = document.createElement('a');
      terms.href = '/policies/terms-of-service';
      terms.textContent = copy.terms;
      disclaimer.replaceChildren(copy.consent, privacy, copy.and, terms, copy.end);
    }
  };
  const styledRoots = new WeakSet();
  const attachStyles = () => {
    for (const host of document.querySelectorAll('shopify-forms-embed')) {
      const root = host.shadowRoot;
      if (!root || styledRoots.has(root)) continue;
      const apply = () => {
        localize(root);
        if (root.querySelector('[data-dw-floating-button-style]')) return;
        const style = document.createElement('style');
        style.setAttribute('data-dw-floating-button-style', '');
        style.textContent = stylesheet;
        root.append(style);
      };
      apply();
      new MutationObserver(apply).observe(root, { childList: true, subtree: true });
      styledRoots.add(root);
    }
    return document.querySelector('shopify-forms-embed')?.shadowRoot;
  };
  let pendingFrame = 0;
  const stopObserving = () => {
    observer.disconnect();
    if (pendingFrame) cancelAnimationFrame(pendingFrame);
    pendingFrame = 0;
  };
  const observer = new MutationObserver((records) => {
    if (pendingFrame) return;
    const containsFormsHost = records.some((record) =>
      Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 &&
        (node.matches('shopify-forms-embed') || node.querySelector('shopify-forms-embed'))
      )
    );
    if (!containsFormsHost) return;
    pendingFrame = requestAnimationFrame(() => {
      pendingFrame = 0;
      if (attachStyles()) stopObserving();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  customElements.whenDefined('shopify-forms-embed').then(() => {
    if (attachStyles()) stopObserving();
    else requestAnimationFrame(() => {
      if (attachStyles()) stopObserving();
    });
  });
  if (attachStyles()) stopObserving();
})();
